import { useCallback, useContext, useState } from "react";
import { getText } from '@educaplay/app-core/language';
import { Dialog } from "./Dialog";
import { MainContext } from "../../contexts/main";

export const ModalCancel = (props) => {
    const { openCancelDialog, setOpenCancelDialog, handleCancel } = props;
    const { mainReducer } = useContext(MainContext);
    const [showTextArea, setShowTextArea] = useState(false);
    const [textareaValue, setTextareaValue] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const currentLicense = mainReducer.state.currentLicense.id;

    const handleChange = useCallback((event) => {
        setTextareaValue(event.target.value);
    }, []);

    const handleSubmit = useCallback(() => {
        if (textareaValue.trim() === '') {
            alert(getText('cancel_dialog_reason_required'));
            return;
        }

        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
        setOpenCancelDialog(false);
        setShowTextArea(false);

        handleCancel(textareaValue.trim());

        setTextareaValue('');
        setIsSubmitting(false);
    }, [textareaValue, isSubmitting, setOpenCancelDialog, handleCancel]);

    const handleCloseCancel = useCallback(() => {
        setOpenCancelDialog(false);
        setShowTextArea(false);
        setTextareaValue('');
    }, [setOpenCancelDialog]);

    return (
        <Dialog open={openCancelDialog} onClose={() => { setOpenCancelDialog(false) }}>
            <div className='dialog__container'>
                <button className="js-modal__close modal__close" onClick={handleCloseCancel} title="{#cerrar#}">
                    <span className="e-icon">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.2931 10.2931C18.6837 9.90261 19.3167 9.90261 19.7072 10.2931C20.0976 10.6837 20.0977 11.3167 19.7072 11.7072L16.4142 15.0002L19.7072 18.2931C20.0976 18.6837 20.0977 19.3167 19.7072 19.7072C19.3167 20.0977 18.6837 20.0976 18.2931 19.7072L15.0002 16.4142L11.7072 19.7072C11.3167 20.0977 10.6837 20.0976 10.2931 19.7072C9.90261 19.3167 9.90261 18.6837 10.2931 18.2931L13.5861 15.0002L10.2931 11.7072C9.90261 11.3167 9.90261 10.6837 10.2931 10.2931C10.6837 9.90261 11.3167 9.90261 11.7072 10.2931L15.0002 13.5861L18.2931 10.2931Z" fill="currentColor"/>
                        </svg>
                    </span>
                </button>
                {!showTextArea && <>
                    <div className='dialog__title'>
                        {getText('cancel_dialog_title')}
                    </div>
                    <div className='dialog__content'>
                        <div className="fomatted-content-left space-top-small">
                            <p>{getText('cancel_dialog_description')}</p>
                            <ul>
                                <li>{getText('cancel_dialog_description_item_1')}</li>
                                <li>{getText('cancel_dialog_description_item_2')}</li>
                                {currentLicense >= 2 && <li>{getText('cancel_dialog_description_integrations')}</li>}
                                {currentLicense >= 3 && <li>{getText('cancel_dialog_description_corporative')}</li>}
                            </ul>
                        </div>
                    </div>
                    <div className='dialog__buttonscontainer'>
                        <button
                            onClick={() => { setShowTextArea(true); }}
                            className='dialog__buttonscontainer__btnaccept'
                        >{getText('continue')}</button>
                    </div>
                </>}
                {showTextArea && <>
                    <div className='dialog__title'>
                        {getText('cancel_form_title')}
                    </div>
                    <div className='dialog__content'>
                        {getText('cancel_form_description')}
                    </div>
                    <div className="e-form">
                        <span className="e-form__input">
                            <textarea
                                id="cancel-form-reason"
                                className='dialog__textarea'
                                maxLength={1000}
                                placeholder={getText('cancel_form_placeholder')}
                                value={textareaValue}
                                onChange={handleChange}
                            />
                        </span>
                    </div>
                    <div className='dialog__buttonscontainer'>
                        <button
                            onClick={handleSubmit}
                            className='dialog__buttonscontainer__btnaccept'
                        >{getText('confirm')}</button>
                    </div>
                </>}
            </div>
        </Dialog>
    )
}